import { createContext, useContext } from 'react';
export const ToastContext = createContext({});
export function useToast() {
    const toast = useContext(ToastContext);
    return toast;
}
